import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { getCardById } from '../../use';
import { SetActiveCardIdByClick } from './setActiveCardIdByClick';

const { registerReducer, dispatch } = useStorymapStore();

export class ToggleCardMultiselect extends Action<StorymapState> {
    public static ACTION_TYPE = 'ToggleCardMultiselect';

    public constructor(public id: string) {
        super(ToggleCardMultiselect.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: ToggleCardMultiselect): void => {
    if (!state.canEdit) {
        return;
    }

    const card = getCardById(action.id);
    if (card != null) {
        card.isMultiselected = !card.isMultiselected;

        if (card.isMultiselected) {
            dispatch(new SetActiveCardIdByClick(card.id));
        }
    }
};

//@ts-ignore
registerReducer(ToggleCardMultiselect.ACTION_TYPE, reducer);